import api from "./apiURL";
import axios from "axios";
import { baseURL } from "../config";

export async function getLookupData() {
  try {
    const response = await axios.get(`${baseURL}/api/v1/lookup/get`);

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function getStates() {
  try {
    const response = await axios.get(
      `${baseURL}/api/v1/lookup/unauth/states/all`
    );

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function getDistricts(data) {
  try {
    const response = await axios.get(
      `${baseURL}/api/v1/lookup/unauth/states/districts/?state=${data}`
    );

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function getPaymentLookup() {
  try {
    const response = await api.get(`${baseURL}/api/v1/lookup/payment/get`);

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function getPincodeDetails(code) {
  try {
    const response = await axios.get(
      `${baseURL}/api/v1/inquiry/location/?pincode=${code}`
    );

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}
